/******************************************************************************

 @File         PVRTShadowVol.cpp

 @Title        PVRTShadowVol

 @Version       @Version      

 @Copyright    Copyright (c) Imagination Technologies Limited.

 @Platform     ANSI compatible

 @Description  Declarations of functions relating to shadow volume generation.

******************************************************************************/

// #include "PVRTGlobal.h"
// #include "PVRTContext.h"
// #include "PVRTFixedPoint.h"
// #include "PVRTMatrix.h"
// #include "PVRTTrans.h"
// #include "PVRTShadowVol.h"
// #include "PVRTError.h"

import {PVRVector3} from "./PVRMaths"


const PVRModelShadow =  function(){


/****************************************************************************
** Defines
****************************************************************************/
const PVRTSHADOWVOLUME_VISIBLE	 =	0x00000001
const PVRTSHADOWVOLUME_NEED_CAP_FRONT =	0x00000002
const PVRTSHADOWVOLUME_NEED_CAP_BACK =	0x00000004
const PVRTSHADOWVOLUME_NEED_ZFAIL =		0x00000008

/****************************************************************************
** Structures
****************************************************************************/
function PVRTShadowVolMEdge(){
    this.wV0 = 0;
    this.wV1 = 0;		//unsigned short	 /*!< Indices of the vertices of the edge */
	this.nVis = 0;			/*!< Bit0 = Visible, Bit1 = Hidden, Bit2 = Reverse Winding */
};

function PVRTShadowVolMTriangle(){
	   this.w = new Uint16Array(3); //[3];	//	unsigned short	/*!< Source indices of the triangle */	
       this.wE0 = 0;
       this.wE1 = 0;
       this.wE2 = 0; //unsigned int  /*!< Indices of the edges of the triangle */
	   this.vNormal = new PVRVector3();			/*!< Triangle normal */
	   this.nWinding = 0;	/*!< BitN = Correct winding for edge N */
};

function PVRTShadowVolShadowMesh() {
	this.pV = []; //PVRTVECTOR3 *	/*!< Unique vertices in object space */
	this.pE = []; // PVRTShadowVolMEdge*
	this.pT = []; //PVRTShadowVolMTriangle	*
	this.nV = 0;		//unsigned int	/*!< Vertex count */
	this.nE = 0;	 //	unsigned int	/*!< Edge count */
		this.nT=0;		//unsigned int/*!< Triangle count */
	this.pivb = [];		//void			*/*!< Two copies of the vertices */
};

/*
	Renderable shadow-volume information:
*/
function PVRTShadowVolShadowVol() {
	this.piib = [];	 //unsigned short			*	/*!< Indices to render the volume */
	this.nIdxCnt = 0;	//unsigned int	/*!< Number of indices in piib */

};


/****************************************************************************
** Build options
****************************************************************************/

/****************************************************************************
** Defines
****************************************************************************/

/****************************************************************************
** Macros
****************************************************************************/

/****************************************************************************
** Structures
****************************************************************************/
function  SVertexShVol (){
    this.x =0.0;
    this.y = 0.0;
    this.z = 0.0;
	this.dwExtrude = 0.0;
};

/****************************************************************************
** Constants
****************************************************************************/
const  c_pwLinesHyperCube = new Uint16Array([
	// Cube0
	0, 1,  2, 3,  0, 2,  1, 3,
	4, 5,  6, 7,  4, 6,  5, 7,
	0, 4,  1, 5,  2, 6,  3, 7,
	// Cube1
	8, 9,  10, 11,  8, 10,  9, 11,
	12, 13,  14, 15,  12, 14,  13, 15,
	8, 12,  9, 13,  10, 14,  11, 15,
	// Hyper cube jn
	0, 8,  1, 9,  2, 10,  3, 11,
	4, 12,  5, 13,  6, 14,  7, 15
]);
const c_pvRect = [
    new PVRVector3( -1, -1, 1 ),
    new PVRVector3( -1, 1, 1 ),
    new PVRVector3( -1, -1, 1 ),
    new PVRVector3( -1, 1, 1 )
];

/****************************************************************************
** Shared globals
****************************************************************************/

/****************************************************************************
** Globals
****************************************************************************/

/****************************************************************************
** Declarations
****************************************************************************/

/****************************************************************************
** Code
****************************************************************************/
/****************************************************************************
@Function		FindOrCreateVertex
@Modified		psMesh				The mesh to check against/add to
@Input			pV					The vertex to compare/add
@Return			unsigned short		The array index of the vertex
@Description	Searches through the mesh data to see if the vertex has
				already been used. If it has, the array index of the vertex
				is returned. If the mesh does not already use the vertex,
				it is appended to the vertex array and the array count is incremented.
				The index in the array of the new vertex is then returned.
****************************************************************************/
//static  FindOrCreateVertex(PVRTShadowVolShadowMesh * const psMesh, const PVRTVECTOR3 * const pV) { //unsigned short
function  findOrCreateVertex( psMesh,  pv) { //unsigned short
		//let wCurr = 0.0 ;   //unsigned short

	/*
		First check whether we already have a vertex here
	*/
	for(let wCurr = 0; wCurr < psMesh.nV; wCurr++) {
       if (psMesh.pV[wCurr] === pv){return wCurr}
		//if(memcmp(&psMesh.pV[wCurr], pV, sizeof(*pV)) == 0) {
			/* Don't do anything more if the vertex already exists */	
		//}
	}
	/*
		Add the vertex then!
	*/
	psMesh.pV[psMesh.nv] = pv;
    psMesh.nV++;
	return   psMesh.nV-1;  //(unsigned short)//
}

/****************************************************************************
@Function		FindOrCreateEdge
@Modified		psMesh				The mesh to check against/add to
@Input			pv0					The first point that defines the edge
@Input			pv1					The second point that defines the edge
@Return			PVRTShadowVolMEdge	The index of the found/created edge in the
									mesh's array
@Description	Searches through the mesh data to see if the edge has
				already been used. If it has, the array index of the edge
				is returned. If the mesh does not already use the edge,
				it is appended to the edge array and the array cound is incremented.
				The index in the array of the new edge is then returned.
****************************************************************************/
function FindOrCreateEdge( psMesh, pv0,  pv1) {

//static unsigned int FindOrCreateEdge(PVRTShadowVolShadowMesh * const psMesh, const PVRTVECTOR3 * const pv0, const PVRTVECTOR3 * const pv1) {
//	let 	nCurr = 0;  //	unsigned short	
    let	wV0 = 0;
    let  wV1 = 0; //	unsigned short	
	
	wV0 = findOrCreateVertex(psMesh, pv0);
	wV1 = findOrCreateVertex(psMesh, pv1);

	
	/*
		First check whether we already have a edge here
	*/
	for(let nCurr = 0; nCurr < psMesh.nE; nCurr++) {
		if(
			(psMesh.pE[nCurr].wV0 === wV0 && psMesh.pE[nCurr].wV1 === wV1) ||
			(psMesh.pE[nCurr].wV0 === wV1 && psMesh.pE[nCurr].wV1 === wV0))
		{
			/* Don't do anything more if the edge already exists */						
			return nCurr;
		}
	}
	/*
		Add the edge then!
	*/
	//psMesh.pE.push(new PVRTShadowVolMEdge());
      //  console.log(psMesh);


    psMesh.pE[psMesh.nE].wV0	= wV0;
	psMesh.pE[psMesh.nE].wV1	= wV1;
	psMesh.pE[psMesh.nE].nVis	= 0;
    psMesh.nE++
	return psMesh.nE-1 ;
}

/****************************************************************************
@Function		CrossProduct
@Output			pvOut			The resultant vector
@Input			pv0				Vector zero
@Input			pv1				Vector one
@Input			pv2				Vector two
@Description	Finds the vector between vector zero and vector one,
				and the vector between vector zero and vector two.
				These two resultant vectors are then multiplied together
				and the result is assigned to the output vector.
****************************************************************************/
//function CrossProduct(
//	PVRTVECTOR3 * const pvOut,
//	const PVRTVECTOR3 * const pv0,
//	const PVRTVECTOR3 * const pv1,
  //  const PVRTVECTOR3 * const pv2)
    
    function CrossProduct(
     
      pv0,
        pv1,
        pv2)
{
    let v0 = new PVRVector3();
    let  v1 = new PVRVector3();

	v0.data[0] = pv1.data[0] - pv0.data[0];
	v0.data[1] = pv1.data[1] - pv0.data[1];
	v0.data[2] = pv1.data[2] - pv0.data[2];

	v1.data[0] = pv2.data[0] - pv0.data[0];
	v1.data[1] = pv2.data[1] - pv0.data[1];
	v1.data[2] = pv2.data[2] - pv0.data[2];

	return     PVRVector3.cross(v0,v1);  //    PVRTMatrixVec3   CrossProduct(*pvOut, v0, v1);
}

/****************************************************************************
@Function		FindOrCreateTriangle
@Modified		psMesh			The mesh to check against/add to
@Input			pv0				Vertex zero
@Input			pv1				Vertex one
@Input			pv2				Vertex two
@Description	Searches through the mesh data to see if the triangle has
				already been used. If it has, the function returns.
				If the mesh does not already use the triangle,
				it is appended to the triangle array and the array cound is incremented.
****************************************************************************/
// static void FindOrCreateTriangle(
// 	PVRTShadowVolShadowMesh	* const psMesh,
// 	const PVRTVECTOR3	* const pv0,
// 	const PVRTVECTOR3	* const pv1,
//     const PVRTVECTOR3	* const pv2)
    
 function FindOrCreateTriangle(
        psMesh,
        pv0,
        pv1,
        pv2)
{

   
//let	nCurr = 0;
    let psE0 = []; //(PVRTShadowVolMEdge	*)
    let psE1 = [];
    let psE2 = [];

	

	let wE0 = FindOrCreateEdge(psMesh, pv0, pv1);
	let wE1 = FindOrCreateEdge(psMesh, pv1, pv2);
	let wE2 = FindOrCreateEdge(psMesh, pv2, pv0);
	
	if(wE0 === wE1 || wE1 === wE2 || wE2 === wE0) {
		/* Don't add degenerate triangles */
		//_RPT0(_CRT_WARN, "FindOrCreateTriangle() Degenerate triangle.\n");
		return;
	}

	/*
		First check whether we already have a triangle here
	*/
	for(let nCurr = 0; nCurr < psMesh.nT; nCurr++) {
		if(
			(psMesh.pT[nCurr].wE0 === wE0 || psMesh.pT[nCurr].wE0 === wE1 || psMesh.pT[nCurr].wE0 === wE2) &&
			(psMesh.pT[nCurr].wE1 === wE0 || psMesh.pT[nCurr].wE1 === wE1 || psMesh.pT[nCurr].wE1 === wE2) &&
			(psMesh.pT[nCurr].wE2 === wE0 || psMesh.pT[nCurr].wE2 === wE1 || psMesh.pT[nCurr].wE2 === wE2))
		{
			/* Don't do anything more if the triangle already exists */
			return;
		}
	}

	/*
		Add the triangle then!
    */
  // psMesh.pT.push(new PVRTShadowVolMTriangle());

	psMesh.pT[psMesh.nT].wE0 = wE0;
	psMesh.pT[psMesh.nT].wE1 = wE1;
	psMesh.pT[psMesh.nT].wE2 = wE2;

	psE0 = psMesh.pE[wE0];
	psE1 = psMesh.pE[wE1];
	psE2 = psMesh.pE[wE2];

	/*
		Store the triangle indices; these are indices into the shadow mesh, not the source model indices
	*/
	if(psE0.wV0 === psE1.wV0 || psE0.wV0 === psE1.wV1)
		psMesh.pT[psMesh.nT].w[0] = psE0.wV1;
	else
		psMesh.pT[psMesh.nT].w[0] = psE0.wV0;

	if(psE1.wV0 === psE2.wV0 || psE1.wV0 === psE2.wV1)
		psMesh.pT[psMesh.nT].w[1] = psE1.wV1;
	else
		psMesh.pT[psMesh.nT].w[1] = psE1.wV0;

	if(psE2.wV0 === psE0.wV0 || psE2.wV0 === psE0.wV1)
		psMesh.pT[psMesh.nT].w[2] = psE2.wV1;
	else
		psMesh.pT[psMesh.nT].w[2] = psE2.wV0;

    /* Calculate the triangle normal */
   
	psMesh.pT[psMesh.nT].vNormal = CrossProduct( pv0, pv1, pv2);

	/* Check which edges have the correct winding order for this triangle */
	psMesh.pT[psMesh.nT].nWinding = 0;
	// if(memcmp(&psMesh.pV[psE0.wV0], pv0, sizeof(*pv0)) == 0) psMesh.pT[psMesh.nT].nWinding |= 0x01;
	// if(memcmp(&psMesh.pV[psE1.wV0], pv1, sizeof(*pv1)) == 0) psMesh.pT[psMesh.nT].nWinding |= 0x02;
	// if(memcmp(&psMesh.pV[psE2.wV0], pv2, sizeof(*pv2)) == 0) psMesh.pT[psMesh.nT].nWinding |= 0x04;

      if( psMesh.pV[psE0.wV0]=== pv0) psMesh.pT[psMesh.nT].nWinding |= 0x01;
	  if(psMesh.pV[psE1.wV0] === pv1) psMesh.pT[psMesh.nT].nWinding |= 0x02;
     if(psMesh.pV[psE2.wV0] === pv2) psMesh.pT[psMesh.nT].nWinding |= 0x04;

	psMesh.nT++;
}

/*!***********************************************************************
@Function	PVRTShadowVolMeshCreateMesh
@Modified	psMesh		The shadow volume mesh to populate
@Input		pVertex		A list of vertices
@Input		nNumVertex	The number of vertices
@Input		pFaces		A list of faces
@Input		nNumFaces	The number of faces
@Description	Creates a mesh format suitable for generating shadow volumes
*************************************************************************/
// void PVRTShadowVolMeshCreateMesh(
// 	PVRTShadowVolShadowMesh		* const psMesh,
// 	const float				* const pVertex,
// 	const unsigned int		nNumVertex,
// 	const unsigned short	* const pFaces,
// 	const unsigned int		nNumFaces)

PVRModelShadow.prototype.PVRTShadowVolMeshCreateMesh = function(
		 //psMesh,
	     pVertex,
		nNumVertex,
 pFaces,
    	nNumFaces)
    
{

   
		//let nCurr=0;//unsigned int

	/*
		Prep the structure to return
	*/
	//memset(psMesh, 0, sizeof(*psMesh));
let psMesh = new PVRTShadowVolShadowMesh();

	/*
		Allocate some working space to find the unique vertices
	*/
//	psMesh.pV = (PVRTVECTOR3*)malloc(nNumVertex * sizeof(*psMesh.pV));
    psMesh.pV = new Array(nNumVertex);
    for (let i =0 ; i<nNumVertex; i++) {	psMesh.pV[i] = new PVRVector3() ;}

   // psMesh.pE = (PVRTShadowVolMEdge*)malloc(nNumFaces * sizeof(*psMesh.pE) * 3);
    psMesh.pE = new Array(nNumFaces * 3);
    for (let i =0 ; i<nNumFaces*3; i+=3) {	
        psMesh.pE[i] = new PVRTShadowVolMEdge();
        psMesh.pE[i+1] = new PVRTShadowVolMEdge();
        psMesh.pE[i+2] = new PVRTShadowVolMEdge();
    }



	//psMesh.pT = (PVRTShadowVolMTriangle*)malloc(nNumFaces * sizeof(*psMesh.pT));
    psMesh.pT = new Array(nNumFaces);
    for (let i =0 ; i<nNumFaces; i++) {	psMesh.pT[i] = new PVRTShadowVolMTriangle() ;}


    // _ASSERT(psMesh.pV);
	// _ASSERT(psMesh.pE);
    // _ASSERT(psMesh.pT);
    
   

	for(let nCurr = 0; nCurr < nNumFaces; nCurr++) {



		FindOrCreateTriangle(psMesh,
			pVertex[pFaces[3 * nCurr + 0]],
			pVertex[pFaces[3 * nCurr + 1]],
			pVertex[pFaces[3 * nCurr + 2]]);
	}

	// _ASSERT(psMesh.nV <= nNumVertex);
	// _ASSERT(psMesh.nE < nNumFaces * 3);
	// _ASSERT(psMesh.nT == nNumFaces);

	// _RPT2(_CRT_WARN, "Unique vertices : %d (from %d)\n", psMesh.nV, nNumVertex);
	// _RPT2(_CRT_WARN, "Unique edges    : %d (from %d)\n", psMesh.nE, nNumFaces * 3);
	// _RPT2(_CRT_WARN, "Unique triangles: %d (from %d)\n", psMesh.nT, nNumFaces);

	/*
		Create the real unique lists
	*/
	// psMesh.pV = (PVRTVECTOR3*)realloc(psMesh.pV, psMesh.nV * sizeof(*psMesh.pV));
	// psMesh.pE = (PVRTShadowVolMEdge*)realloc(psMesh.pE, psMesh.nE * sizeof(*psMesh.pE));
    // psMesh.pT = (PVRTShadowVolMTriangle*)realloc(psMesh.pT, psMesh.nT * sizeof(*psMesh.pT));
    

    psMesh.pV = new Array(psMesh.nV);//(PVRTVECTOR3*)realloc(psMesh.pV, psMesh.nV * sizeof(*psMesh.pV));
    for (let i =0 ; i<psMesh.nV; i++) {	psMesh.pV[i] = new PVRVector3() ;}

    
    psMesh.pE = new Array(psMesh.nE);//(PVRTShadowVolMEdge*)realloc(psMesh.pE, psMesh.nE * sizeof(*psMesh.pE));
    for (let i =0 ; i<psMesh.nE; i++) {	psMesh.pE[i] = new PVRTShadowVolMEdge() ;}


    psMesh.pT = new Array(psMesh.nT);//(PVRTShadowVolMTriangle*)realloc(psMesh.pT, psMesh.nT * sizeof(*psMesh.pT));
    for (let i =0 ; i<psMesh.nT; i++) {	psMesh.pT[i] = new PVRTShadowVolMTriangle() ;}

	// _ASSERT(psMesh.pV);
	// _ASSERT(psMesh.pE);
	// _ASSERT(psMesh.pT);

// #if defined(_DEBUG) && !defined(_UNICODE) && defined(_WIN32)
// 	/*
// 		Check we have sensible model data
// 	*/
// 	{
// 		unsigned int nTri, nEdge;
// 		PVRTERROR_OUTPUT_DEBUG("ShadowMeshCreate() Sanity check...");

// 		for(nEdge = 0; nEdge < psMesh.nE; nEdge++) {
// 			nCurr = 0;

// 			for(nTri = 0; nTri < psMesh.nT; nTri++) {
// 				if(psMesh.pT[nTri].wE0 == nEdge)
// 					nCurr++;

// 				if(psMesh.pT[nTri].wE1 == nEdge)
// 					nCurr++;

// 				if(psMesh.pT[nTri].wE2 == nEdge)
// 					nCurr++;
// 			}

// 			/*
// 				Every edge should be referenced exactly twice. 
// 				If they aren't then the mesh isn't closed which will cause problems when rendering the shadows.
// 			*/
// 			_ASSERTE(nCurr == 2);
// 		}

// 		PVRTERROR_OUTPUT_DEBUG("done.\n");
// 	}
// #endif
return psMesh;
}

/*!***********************************************************************
@Function		PVRTShadowVolMeshInitMesh
@Input			psMesh	The shadow volume mesh
@Input			pContext	A struct for API specific data
@Returns 		True on success
@Description	Init the mesh
*************************************************************************/
// bool PVRTShadowVolMeshInitMesh(
// 	PVRTShadowVolShadowMesh		* const psMesh,
// 	const SPVRTContext		* const pContext)
PVRModelShadow.prototype.PVRTShadowVolMeshInitMesh = function(gl,
			 psMesh, psRenderIDs)
    //  pContext)
{
	//let	nCurr = 0;
	let   pvData = {};  //SVertexShVol *

// #if defined(BUILD_OGL)
// 	_ASSERT(pContext && pContext.pglExt);

// 	if(!pContext || !pContext.pglExt)
// 		return false;
// #endif

// // #if defined(BUILD_OGLES2) || defined(BUILD_OGLES) || defined(BUILD_OGLES3)
// // 	PVRT_UNREFERENCED_PARAMETER(pContext);
// // #endif
// 	_ASSERT(psMesh);
// 	_ASSERT(psMesh.nV);
// 	_ASSERT(psMesh.nE);
// 	_ASSERT(psMesh.nT);

// 	/*
// 		Allocate a vertex buffer for the shadow volumes
// 	*/
// 	_ASSERT(psMesh.pivb == NULL);
// 	_RPT3(_CRT_WARN, "ShadowMeshInitMesh() %5d byte VB (%3dv x 2 x size(%d))\n", psMesh.nV * 2 * sizeof(*pvData), psMesh.nV, sizeof(*pvData));

// #if defined(BUILD_DX9)
// 	hRes = pContext.pDev.CreateVertexBuffer(psMesh.nV * 2 * sizeof(*pvData), D3DUSAGE_WRITEONLY, 0, D3DPOOL_DEFAULT, &psMesh.pivb, NULL);
// 	if(FAILED(hRes)) {
// 		_ASSERT(false);
// 		return false;
// 	}

// 	hRes = psMesh.pivb.Lock(0, 0, (void**)&pvData, 0);
// 	if(FAILED(hRes)) {
// 		_ASSERT(false);
// 		return false;
// 	}
// #endif

// #if defined(BUILD_DX11)
// 	D3D11_BUFFER_DESC sVBBufferDesc;
// 	sVBBufferDesc.ByteWidth		= psMesh.nV * 2 * 3 * sizeof(*pvData);
// 	sVBBufferDesc.Usage			= D3D11_USAGE_DYNAMIC;
// 	sVBBufferDesc.BindFlags		= D3D11_BIND_VERTEX_BUFFER;
// 	sVBBufferDesc.CPUAccessFlags= 0;
// 	sVBBufferDesc.MiscFlags		= 0;

// 	hRes = pContext.pDev.CreateBuffer(&sVBBufferDesc, NULL, &psMesh.pivb) != S_OK;

// 	if(FAILED(hRes)) 
// 	{
// 		_ASSERT(false);
// 		return false;
// 	}

// 	D3D11_MAPPED_SUBRESOURCE data;
// 	ID3D11DeviceContext *pDeviceContext = 0;
// 	pContext.pDev.GetImmediateContext(&pDeviceContext);
// 	hRes = pDeviceContext.Map(psMesh.pivb, 0, D3D11_MAP_WRITE_DISCARD, NULL, &data);

// 	if(FAILED(hRes)) 
// 	{
// 		_ASSERT(false);
// 		return false;
// 	}

// 	pvData = (SVertexShVol*) data.pData;
// #endif

//#if defined(BUILD_OGL) || defined(BUILD_OGLES) || defined(BUILD_OGLES2) || defined(BUILD_OGLES3)
    
     psMesh.pivb =  new Array(psMesh.nV * 2 ); //* sizeof(*pvData));
      
    for(let i=0; i< psMesh.nV * 2 ; i++)  psMesh.pivb[i] =  new SVertexShVol();

    pvData = psMesh.pivb;
//#endif

	/*
		Fill the vertex buffer with two subtly different copies of the vertices
	*/
// 	for(let nCurr = 0; nCurr < psMesh.nV; ++nCurr) 
// 	{
// 		pvData[nCurr].x			= psMesh.pV[nCurr].data[0];
// 		pvData[nCurr].y			= psMesh.pV[nCurr].data[1];
// 		pvData[nCurr].z			= psMesh.pV[nCurr].data[2];
// 		pvData[nCurr].dwExtrude = 0;

// //#if defined(BUILD_OGLES)
// 	//	pvData[nCurr].fWeight = 1;
// 	//	pvData[nCurr + psMesh.nV].fWeight = 1;
// // #endif
//         pvData[nCurr + psMesh.nV].x  =  pvData[nCurr].x;
//         pvData[nCurr + psMesh.nV].y  =  pvData[nCurr].y;
//         pvData[nCurr + psMesh.nV].z  =  pvData[nCurr].z;
// 		pvData[nCurr + psMesh.nV].dwExtrude	= 0x04030201;		// Order is wzyx
//     }
    
   

 	for(let nCurr = 0; nCurr < psMesh.nV; ++nCurr) 
	{
		pvData[nCurr].x			= psMesh.pV[nCurr].data[0];
		pvData[nCurr].y			= psMesh.pV[nCurr].data[1];
		pvData[nCurr].z			= psMesh.pV[nCurr].data[2];
		pvData[nCurr].dwExtrude = 0;

//#if defined(BUILD_OGLES)
	//	pvData[nCurr].fWeight = 1;
	//	pvData[nCurr + psMesh.nV].fWeight = 1;
// #endif
        pvData[nCurr + psMesh.nV].x  =  pvData[nCurr].x;
        pvData[nCurr + psMesh.nV].y  =  pvData[nCurr].y;
        pvData[nCurr + psMesh.nV].z  =  pvData[nCurr].z;
		pvData[nCurr + psMesh.nV].dwExtrude	= 0x04030201;		// Order is wzyx
    }

    var buffer = new ArrayBuffer(pvData.length*16);
    let dv = new DataView(buffer);
    for(let i = 0; i<pvData.length; i++ ){
      let data = pvData[i];
    dv.setFloat32(16*i, data.x, true);
    dv.setFloat32(16*i+4, data.y, true);
    dv.setFloat32(16*i+8, data.z, true);
    dv.setUint32(16*i+12, data.dwExtrude, true);
    }


    if (!psRenderIDs[0]) {
        psRenderIDs[0] = gl.createBuffer();
    }
   gl.bindBuffer(gl.ARRAY_BUFFER, psRenderIDs[0] );
   gl.bufferData(gl.ARRAY_BUFFER,  dv, gl.STATIC_DRAW); 
   gl.bindBuffer(gl.ARRAY_BUFFER, null );


// #if defined(BUILD_DX9)
// 	psMesh.pivb.Unlock();
// #endif

// #if defined(BUILD_DX10)
// 	D3D10_BUFFER_DESC sBufDesc;
// 	sBufDesc.ByteWidth		= psMesh.nV * 2 * sizeof(*pvData);
// 	sBufDesc.Usage			= D3D10_USAGE_IMMUTABLE;
// 	sBufDesc.BindFlags		= D3D10_BIND_VERTEX_BUFFER;
// 	sBufDesc.CPUAccessFlags	= 0;
// 	sBufDesc.MiscFlags		= 0;

// 	D3D10_SUBRESOURCE_DATA sSRData;
// 	sSRData.pSysMem				= pvData;

// 	hRes = pContext.pDev.CreateBuffer(&sBufDesc, &sSRData, &psMesh.pivb);
// 	if(FAILED(hRes))
// 	{
// 		_ASSERT(false);
// 		return false;
// 	}
// #endif
// #if defined(BUILD_DX11)
// 	pDeviceContext.Unmap(psMesh.pivb, 0);
// #endif
	return true;
}

/*!***********************************************************************
@Function		PVRTShadowVolMeshInitVol
@Modified		psVol	The shadow volume struct
@Input			psMesh	The shadow volume mesh
@Input			pContext	A struct for API specific data
@Returns		True on success
@Description	Init the renderable shadow volume information.
*************************************************************************/
// bool PVRTShadowVolMeshInitVol(
// 	PVRTShadowVolShadowVol			* const psVol,
// 	const PVRTShadowVolShadowMesh	* const psMesh,
//     const SPVRTContext		* const pContext)
    
PVRModelShadow.prototype.PVRTShadowVolMeshInitVol= function(
      
       psMesh)
   //  pContext)

{
   let  psVol = new PVRTShadowVolShadowVol();
//#if defined(BUILD_OGLES2) || defined(BUILD_OGLES) || defined(BUILD_OGL) || defined(BUILD_OGLES3)
//	PVRT_UNREFERENCED_PARAMETER(pContext);

	// _ASSERT(psVol);
	// _ASSERT(psMesh);
	// _ASSERT(psMesh.nV);
	// _ASSERT(psMesh.nE);
	// _ASSERT(psMesh.nT);

	//_RPT1(_CRT_WARN, "ShadowMeshInitVol() %5d byte IB\n", psMesh.nT * 2 * 3 * sizeof(unsigned short));

	/*
		Allocate a index buffer for the shadow volumes
	*/
// #if defined(_DEBUG)
// 	psVol.nIdxCntMax = psMesh.nT * 2 * 3;
// #endif
// #if defined(BUILD_DX9)
// 	hRes = pContext.pDev.CreateIndexBuffer(psMesh.nT * 2 * 3 * sizeof(unsigned short),
// 		D3DUSAGE_DYNAMIC | D3DUSAGE_WRITEONLY, D3DFMT_INDEX16, D3DPOOL_DEFAULT, &psVol.piib, NULL);
// 	if(FAILED(hRes)) {
// 		_ASSERT(false);
// 		return false;
// 	}
// #endif
// #if defined(BUILD_DX10)
// 	D3D10_BUFFER_DESC sIdxBuferDesc;
// 	sIdxBuferDesc.ByteWidth		= psMesh.nT * 2 * 3 * sizeof(unsigned short);
// 	sIdxBuferDesc.Usage			= D3D10_USAGE_DYNAMIC;
// 	sIdxBuferDesc.BindFlags		= D3D10_BIND_INDEX_BUFFER;
// 	sIdxBuferDesc.CPUAccessFlags= 0;
// 	sIdxBuferDesc.MiscFlags		= 0;

// 	hRes = pContext.pDev.CreateBuffer(&sIdxBuferDesc, NULL, &psVol.piib) != S_OK;

// 	if(FAILED(hRes)) {
// 		_ASSERT(false);
// 		return false;
// 	}
// #endif
// #if defined(BUILD_DX11)
// 	D3D11_BUFFER_DESC sIdxBuferDesc;
// 	sIdxBuferDesc.ByteWidth		= psMesh.nT * 2 * 3 * sizeof(unsigned short);
// 	sIdxBuferDesc.Usage			= D3D11_USAGE_DYNAMIC;
// 	sIdxBuferDesc.BindFlags		= D3D11_BIND_INDEX_BUFFER;
// 	sIdxBuferDesc.CPUAccessFlags= 0;
// 	sIdxBuferDesc.MiscFlags		= 0;

// 	hRes = pContext.pDev.CreateBuffer(&sIdxBuferDesc, NULL, &psVol.piib) != S_OK;

// 	if(FAILED(hRes)) {
// 		_ASSERT(false);
// 		return false;
// 	}
// #endif
//#if defined(BUILD_OGL) || defined(BUILD_OGLES) || defined(BUILD_OGLES2) || defined(BUILD_OGLES3)
	psVol.piib =    new  Uint16Array(  psMesh.nT * 2 * 3  );//  (unsigned short*)malloc(psMesh.nT * 2 * 3 * sizeof(unsigned short));
//#endif
return psVol;
	//return true;
}

/*!***********************************************************************
@Function		PVRTShadowVolMeshDestroyMesh
@Input			psMesh	The shadow volume mesh to destroy
@Description	Destroys all shadow volume mesh data created by PVRTShadowVolMeshCreateMesh
*************************************************************************/
// function PVRTShadowVolMeshDestroyMesh(
// 	PVRTShadowVolShadowMesh		* const psMesh)
function PVRTShadowVolMeshDestroyMesh(
	 psMesh)
{
	psMesh.pV = null;
	psMesh.pE = null;
	psMesh.pT = null;
}

/*!***********************************************************************
@Function		PVRTShadowVolMeshReleaseMesh
@Input			psMesh	The shadow volume mesh to release
@Description	Releases all shadow volume mesh data created by PVRTShadowVolMeshInitMesh
*************************************************************************/
// void PVRTShadowVolMeshReleaseMesh(
// 	PVRTShadowVolShadowMesh		* const psMesh)
function PVRTShadowVolMeshReleaseMesh(
     psMesh)
{

psMesh.pivb = null;

}

/*!***********************************************************************
@Function		PVRTShadowVolMeshReleaseVol
@Input			psVol	The shadow volume information to release
@Description	Releases all data create by PVRTShadowVolMeshInitVol
*************************************************************************/
// function PVRTShadowVolMeshReleaseVol(
//     PVRTShadowVolShadowVol			* const psVol)
function PVRTShadowVolMeshReleaseVol(
    psVol)
{

	psVol.piib = null;

}

/*!***********************************************************************
@Function		PVRTShadowVolSilhouetteProjectedBuild
@Modified		psVol	The shadow volume information
@Input			dwVisFlags	Shadow volume creation flags
@Input			psMesh	The shadow volume mesh
@Input			pvLightModel	The light position/direction
@Input			bPointLight		Is the light a point light
@Input			pContext	A struct for passing in API specific data
@Description	Using the light set up the shadow volume so it can be extruded.
*************************************************************************/
// void PVRTShadowVolSilhouetteProjectedBuild(
// 	PVRTShadowVolShadowVol			* const psVol,
// 	const unsigned int		dwVisFlags,
// 	const PVRTShadowVolShadowMesh	* const psMesh,
// 	const PVRTVec3		* const pvLightModel,
// 	const bool				bPointLight,
//     const SPVRTContext * const pContext)
    
    function PVRTShadowVolSilhouetteProjectedBuild(
      psVol,
 	dwVisFlags,
     psMesh,
 pvLightModel,
    bPointLight,
      pContext)
{
    PVRTShadowVolSilhouetteProjectedBuild(psVol, dwVisFlags,psMesh, pvLightModel, bPointLight, pContext);
//	PVRTShadowVolSilhouetteProjectedBuild(psVol, dwVisFlags,psMesh, (PVRTVECTOR3*) pvLightModel, bPointLight, pContext);
}

/*!***********************************************************************
@Function		PVRTShadowVolSilhouetteProjectedBuild
@Modified		psVol	The shadow volume information
@Input			dwVisFlags	Shadow volume creation flags
@Input			psMesh	The shadow volume mesh
@Input			pvLightModel	The light position/direction
@Input			bPointLight		Is the light a point light
@Input			pContext	A struct for passing in API specific data
@Description	Using the light set up the shadow volume so it can be extruded.
*************************************************************************/
// void PVRTShadowVolSilhouetteProjectedBuild(
// 	PVRTShadowVolShadowVol			* const psVol,
// 	const unsigned int		dwVisFlags,
// 	const PVRTShadowVolShadowMesh	* const psMesh,
// 	const PVRTVECTOR3		* const pvLightModel,
// 	const bool				bPointLight,
//     const SPVRTContext * const pContext)
    
PVRModelShadow.prototype.PVRTShadowVolSilhouetteProjectedBuild = function(gl,
        psVol,
        dwVisFlags,
        psMesh,
        pvLightModel,
        bPointLight, psRenderIDs){
    //  pContext)
        
let v = new PVRVector3();
let psTri = []; // PVRTShadowVolMTriangle*
let	psEdge = [];  //PVRTShadowVolMEdge		*
let pwIdx = []; //unsigned short	*

//let	nCurr = 0;
let		f = 0;

	/*
		Lock the index buffer; this is where we create the shadow volume
	*/
	//_ASSERT(psVol && psVol.piib);
//#if defined(BUILD_OGL) || defined(BUILD_OGLES) || defined(BUILD_OGLES2) || defined(BUILD_OGLES3)
//	PVRT_UNREFERENCED_PARAMETER(pContext);
//#endif
// #if defined(BUILD_DX9)
// 	hRes = psVol.piib.Lock(0, 0, (void**)&pwIdx, D3DLOCK_DISCARD);
// 	_ASSERT(SUCCEEDED(hRes));
// #endif
// #if defined(BUILD_DX11)
// 	_ASSERT(pContext);

// 	if(!pContext)
// 		return;

// 	D3D11_MAPPED_SUBRESOURCE data;
// 	ID3D11DeviceContext *pDeviceContext = 0;
// 	pContext.pDev.GetImmediateContext(&pDeviceContext);
// 	hRes = pDeviceContext.Map(psVol.piib, 0, D3D11_MAP_WRITE_DISCARD, NULL, &data);
// 	pwIdx = (unsigned short*) data.pData;

// 	_ASSERT(SUCCEEDED(hRes));
// #endif
// #if defined(BUILD_OGL) || defined(BUILD_OGLES) || defined(BUILD_OGLES2) || defined(BUILD_OGLES3)
	pwIdx = psVol.piib;
//#endif

	psVol.nIdxCnt = 0;

	// Run through triangles, testing which face the From point
	for(let nCurr = 0; nCurr < psMesh.nT; ++nCurr) 
	{
       // PVRTShadowVolMEdge *pE0, *pE1, *pE2;
        

		psTri = psMesh.pT[nCurr];
	let	pE0 = psMesh.pE[psTri.wE0];
	let	pE1 = psMesh.pE[psTri.wE1];
	let	pE2 = psMesh.pE[psTri.wE2];

		if(bPointLight) {
			v.data[0] = psMesh.pV[pE0.wV0].data[0] - pvLightModel.data[0];
			v.data[1] = psMesh.pV[pE0.wV0].data[1] - pvLightModel.data[1];
			v.data[2] = psMesh.pV[pE0.wV0].data[2] - pvLightModel.data[2];
			f = PVRVector3.dot(psTri.vNormal, v);
		} else {
			f = PVRVector3.dot(psTri.vNormal, pvLightModel);
		}

		if(f >= 0) {
			/* Triangle is in the light */
			pE0.nVis |= 0x01;
			pE1.nVis |= 0x01;
			pE2.nVis |= 0x01;

			if(dwVisFlags & PVRTSHADOWVOLUME_NEED_CAP_FRONT) 
			{
				// Add the triangle to the volume, unextruded.
				pwIdx[psVol.nIdxCnt+0] = psTri.w[0];
				pwIdx[psVol.nIdxCnt+1] = psTri.w[1];
				pwIdx[psVol.nIdxCnt+2] = psTri.w[2];
				psVol.nIdxCnt += 3;
			}
		} else {
			/* Triangle is in shade; set Bit3 if the winding order needs reversed */
			pE0.nVis |= (0x02 | ((psTri.nWinding & 0x01) << 2));
			pE1.nVis |= (0x02 | ((psTri.nWinding & 0x02) << 1));
			pE2.nVis |= (0x02 | (psTri.nWinding & 0x04));

			if(dwVisFlags & PVRTSHADOWVOLUME_NEED_CAP_BACK) {
				// Add the triangle to the volume, extruded.
				// psMesh.nV is used as an offst so that the new index refers to the 
				// corresponding position in the second array of vertices (which are extruded)
				pwIdx[psVol.nIdxCnt+0] =  psMesh.nV + psTri.w[0];
				pwIdx[psVol.nIdxCnt+1] =  psMesh.nV + psTri.w[1];
				pwIdx[psVol.nIdxCnt+2] = psMesh.nV + psTri.w[2];
				psVol.nIdxCnt += 3;
			}
		}
	}

// #if defined(_DEBUG)
// 	_ASSERT(psVol.nIdxCnt <= psVol.nIdxCntMax);
// 	for(nCurr = 0; nCurr < psVol.nIdxCnt; ++nCurr) {
// 		_ASSERT(pwIdx[nCurr] < psMesh.nV*2);
// 	}
// #endif

	/*
		Run through edges, testing which are silhouette edges
	*/
	for(let nCurr = 0; nCurr < psMesh.nE; nCurr++) {
		psEdge = psMesh.pE[nCurr];

		if((psEdge.nVis & 0x03) === 0x03) {
			/* 	
				Silhouette edge found! 
				The edge is both visible and hidden, 
				so it is along the silhouette of the model 
				(See header notes for more info)
			*/
			if(psEdge.nVis & 0x04) {
				pwIdx[psVol.nIdxCnt+0] = psEdge.wV0;
				pwIdx[psVol.nIdxCnt+1] = psEdge.wV1;
				pwIdx[psVol.nIdxCnt+2] = psEdge.wV0 +  psMesh.nV;

				pwIdx[psVol.nIdxCnt+3] = psEdge.wV0 +  psMesh.nV;
				pwIdx[psVol.nIdxCnt+4] = psEdge.wV1;
				pwIdx[psVol.nIdxCnt+5] = psEdge.wV1 + psMesh.nV;
			} else {
				pwIdx[psVol.nIdxCnt+0] = psEdge.wV1;
				pwIdx[psVol.nIdxCnt+1] = psEdge.wV0;
				pwIdx[psVol.nIdxCnt+2] = psEdge.wV1 +  psMesh.nV;

				pwIdx[psVol.nIdxCnt+3] = psEdge.wV1 +  psMesh.nV;
				pwIdx[psVol.nIdxCnt+4] = psEdge.wV0;
				pwIdx[psVol.nIdxCnt+5] = psEdge.wV0 +  psMesh.nV;
			}

			psVol.nIdxCnt += 6;
		}

		/* Zero for next render */
		psEdge.nVis = 0;
    }
    

    if (!psRenderIDs[1]) {
       // psRenderIDs[0] = gl.createBuffer();
        psRenderIDs[1] = gl.createBuffer();
    }
  // gl.bindBuffer(gl.ARRAY_BUFFER, psRenderIDs[0] );
   gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, psRenderIDs[1]);

   //gl.bufferData(gl.ARRAY_BUFFER,  new Float32Array(psMesh.pivb.buffer), gl.STATIC_DRAW); 
   gl.bufferData(gl.ELEMENT_ARRAY_BUFFER,  pwIdx, gl.STATIC_DRAW); 
 

// #if defined(_DEBUG)
// 	_ASSERT(psVol.nIdxCnt <= psVol.nIdxCntMax);
// 	for(nCurr = 0; nCurr < psVol.nIdxCnt; ++nCurr) {
// 		_ASSERT(pwIdx[nCurr] < psMesh.nV*2);
// 	}
// #endif

// #if defined(BUILD_DX9)
// 	psVol.piib.Unlock();
// #endif
// #if defined(BUILD_DX10)
//     D3D10_BUFFER_DESC sIdxBufferDesc;
//     sIdxBufferDesc.ByteWidth = psVol.nIdxCnt * sizeof(WORD);
//     sIdxBufferDesc.Usage = D3D10_USAGE_DEFAULT;
//     sIdxBufferDesc.BindFlags = D3D10_BIND_INDEX_BUFFER;
//     sIdxBufferDesc.CPUAccessFlags = 0;
//     sIdxBufferDesc.MiscFlags = 0;

//     D3D10_SUBRESOURCE_DATA sIdxBufferData;
//     ZeroMemory(&sIdxBufferData, sizeof(D3D10_SUBRESOURCE_DATA));
//     sIdxBufferData.pSysMem = pwIdx;
//     hRes = pContext.pDev.CreateBuffer(&sIdxBufferDesc, &sIdxBufferData, &psVol.piib);
// 	_ASSERT(SUCCEEDED(hRes));
// #endif
// #if defined(BUILD_DX11)
// 	pDeviceContext.Unmap(psVol.piib, 0);
// #endif
}

/*!***********************************************************************
@Function		IsBoundingBoxVisibleEx
@Input			pBoundingHyperCube	The hypercube to test against
@Input			fCamZ				The camera's position along the z-axis
@Return			bool				Returns true if the bounding box is visible
@Description	This method tests the bounding box's position against
				the camera's position to determine if it is visible. 
				If it is visible, the function returns true.
*************************************************************************/
// static bool IsBoundingBoxVisibleEx(
// 	const PVRTVECTOR4	* const pBoundingHyperCube,
//     const float			fCamZ)
   function IsBoundingBoxVisibleEx(
         pBoundingHyperCube,
        	fCamZ)
{
    let	v = new PVRVector3();
    let vShift = new Array(16)
    for (let i = 0 ; i<16; i++) vShift[i] = new PVRVector3();
    
    
    let	dwClipFlags = 0;
    
let 	i =0;
let  j = 0; //int
        let w0 = 0;
         let w1 = 0;	//unsigned short

	//let dwClipFlags = 0;		// Assume all are off-screen

	i = 8;
	while(i>0)
	{
		i--;

		if(pBoundingHyperCube[i].data[0] <  pBoundingHyperCube[i].data[3])
			dwClipFlags |= 1 << 0;

		if(pBoundingHyperCube[i].data[0] > -pBoundingHyperCube[i].data[3])
			dwClipFlags |= 1 << 1;

		if(pBoundingHyperCube[i].data[1] <  pBoundingHyperCube[i].data[3])
			dwClipFlags |= 1 << 2;

		if(pBoundingHyperCube[i].data[1] > -pBoundingHyperCube[i].data[3])
			dwClipFlags |= 1 << 3;

		if(pBoundingHyperCube[i].data[2] > 0)
			dwClipFlags |= 1 << 4;
	}

	/*
		Volume is hidden if all the vertices are over a screen edge
	*/
	if(dwClipFlags !== 0x1F)
		return false;

	/*
		Well, according to the simple bounding box check, it might be
		visible. Let's now test the view frustrum against the bounding
		cube. (Basically the reverse of the previous test!)

		This catches those cases where a diagonal cube passes near a
		screen edge.
	*/

	// Subtract the camera position from the vertices. I.e. move the camera to 0,0,0
	for(let i = 0; i < 8; ++i) {
		vShift[i].data[0] = pBoundingHyperCube[i].data[0];
		vShift[i].data[1] = pBoundingHyperCube[i].data[1];
		vShift[i].data[2] = pBoundingHyperCube[i].data[2] - fCamZ;
	}

	i = 12;
	while(i>0) {
		i--;

		w0 = c_pwLinesHyperCube[2 * i + 0];
		w1 = c_pwLinesHyperCube[2 * i + 1];

        v = PVRVector3.cross(vShift[w0], vShift[w1]);
		//PVRTMatrixVec3CrossProduct(v, vShift[w0], vShift[w1]);
		dwClipFlags = 0;

		j = 4;
		while(j>0) {
			j--;
            if(PVRVector3.dot(c_pvRect[j], v) < 0)
		//	if(PVRTMatrixVec3DotProduct(c_pvRect[j], v) < 0)
				++dwClipFlags;
		}

		// dwClipFlagsA will be 0 or 4 if the screen edges are on the outside of
		// this bounding-box-silhouette-edge.
		if(dwClipFlags % 4)
			continue;

		j = 8;
		while(j>0) {
			j--;

            let dot = PVRVector3.dot(vShift[j], v)
			if((j !== w0) & (j !== w1) && (dot > 0))
				++dwClipFlags;
		}

		// dwClipFlagsA will be 0 or 18 if this is a silhouette edge of the bounding box
		if(dwClipFlags % 12)
			continue;

		return false;
	}

	return true;
}

/*!***********************************************************************
@Function		IsHyperBoundingBoxVisibleEx
@Input			pBoundingHyperCube	The hypercube to test against
@Input			fCamZ				The camera's position along the z-axis
@Return			bool				Returns true if the bounding box is visible
@Description	This method tests the hypercube bounding box's position against
				the camera's position to determine if it is visible. 
				If it is visible, the function returns true.
*************************************************************************/
// static bool IsHyperBoundingBoxVisibleEx(
// 	const PVRTVECTOR4	* const pBoundingHyperCube,
// 	const float			fCamZ)
function IsHyperBoundingBoxVisibleEx(
	 pBoundingHyperCube,
		fCamZ)
{
	//const PVRTVECTOR4	*pv0;
	//PVRTVECTOR3	v, vShift[16];
    let	v = new PVRVector3();
    let vShift = new Array(16)
    for (let i =0 ; i<16; i++)vShift[i] = new PVRVector3();

    let dwClipFlagsA, dwClipFlagsB = 0; //    unsigned int	
    let  i, j = 0; //	int		
	let	w0, w1 = 0; //unsigned short	

	let pv0 = pBoundingHyperCube[8];
	dwClipFlagsA = 0;		// Assume all are off-screen
	dwClipFlagsB = 0;

	i = 8;
	while(i>0)
	{
		i--;

		// Far
		if(pv0[i].data[0] <  pv0[i].data[3])
			dwClipFlagsA |= 1 << 0;

		if(pv0[i].data[0] > -pv0[i].data[3])
			dwClipFlagsA |= 1 << 1;

		if(pv0[i].data[1] <  pv0[i].data[3])
			dwClipFlagsA |= 1 << 2;

		if(pv0[i].data[1] > -pv0[i].data[3])
			dwClipFlagsA |= 1 << 3;

		if(pv0[i].data[2] >  0)
			dwClipFlagsA |= 1 << 4;

		// Near
		if(pBoundingHyperCube[i].data[0] <  pBoundingHyperCube[i].data[3])
			dwClipFlagsB |= 1 << 0;

		if(pBoundingHyperCube[i].data[0] > -pBoundingHyperCube[i].data[3])
			dwClipFlagsB |= 1 << 1;

		if(pBoundingHyperCube[i].data[1] <  pBoundingHyperCube[i].data[3])
			dwClipFlagsB |= 1 << 2;

		if(pBoundingHyperCube[i].data[1] > -pBoundingHyperCube[i].data[3])
			dwClipFlagsB |= 1 << 3;

		if(pBoundingHyperCube[i].data[2] > 0)
			dwClipFlagsB |= 1 << 4;
	}

	/*
		Volume is hidden if all the vertices are over a screen edge
	*/
	if((dwClipFlagsA | dwClipFlagsB) !== 0x1F)
		return false;

	/*
		Well, according to the simple bounding box check, it might be
		visible. Let's now test the view frustrum against the bounding
		hyper cube. (Basically the reverse of the previous test!)

		This catches those cases where a diagonal hyper cube passes near a
		screen edge.
	*/

	// Subtract the camera position from the vertices. I.e. move the camera to 0,0,0
	for(let i = 0; i < 16; ++i) {
		vShift[i].data[0] = pBoundingHyperCube[i].data[0];
		vShift[i].data[1] = pBoundingHyperCube[i].data[1];
		vShift[i].data[2] = pBoundingHyperCube[i].data[2] - fCamZ;
	}

	i = 32;
	while(i>0) {
		i--;

		w0 = c_pwLinesHyperCube[2 * i + 0];
		w1 = c_pwLinesHyperCube[2 * i + 1];

    //	PVRTMatrixVec3CrossProduct(v, vShift[w0], vShift[w1]);
    v = PVRVector3.cross(vShift[w0], vShift[w1]);
		dwClipFlagsA = 0;

		j = 4;
		while(j>0) {
			j--;

            // if(PVRTMatrixVec3DotProduct(c_pvRect[j], v) < 0)
            if(PVRVector3.dot(c_pvRect[j], v) < 0)
				++dwClipFlagsA;
		}

		// dwClipFlagsA will be 0 or 4 if the screen edges are on the outside of
		// this bounding-box-silhouette-edge.
		if(dwClipFlagsA % 4)
			continue;

		j = 16;
		while(j>0) {
			j--;
let dot =  PVRVector3.dot(c_pvRect[j], v);
			//if((j != w0) & (j != w1) && (PVRTMatrixVec3DotProduct(vShift[j], v) > 0))
            if((j !== w0) & (j !== w1) && dot > 0)
            ++dwClipFlagsA;
		}

		// dwClipFlagsA will be 0 or 18 if this is a silhouette edge of the bounding box
		if(dwClipFlagsA % 18)
			continue;

		return false;
	}

	return true;
}
/*!***********************************************************************
@Function		IsFrontClipInVolume
@Input			pBoundingHyperCube	The hypercube to test against
@Return			bool				
@Description	Returns true if the hypercube is within the view frustrum.
*************************************************************************/
// static bool IsFrontClipInVolume(
//     const PVRTVECTOR4	* const pBoundingHyperCube)
    
function IsFrontClipInVolume(
        pBoundingHyperCube)

{
        let pv0 = [];
        let pv1 = [];//const PVRTVECTOR4 *
			let	dwClipFlags = 0; //	unsigned int
	let			i = 0; //int
		let fScale, x, y, w = 0; //float			

	/*
		OK. The hyper-bounding-box is in the view frustrum.

		Now decide if we can use Z-pass instead of Z-fail.

		TODO: if we calculate the convex hull of the front-clip intersection
		points, we can use the connecting lines to do a more accurate on-
		screen check (currently it just uses the bounding box of the
		intersection points.)
	*/
	dwClipFlags = 0;

	i = 32;
	while(i>0) {
		i--;

		pv0 = pBoundingHyperCube[c_pwLinesHyperCube[2 * i + 0]];
		pv1 = pBoundingHyperCube[c_pwLinesHyperCube[2 * i + 1]];

		// If both coords are negative, or both coords are positive, it doesn't cross the Z=0 plane
		if(pv0.data[2] * pv1.data[2] > 0)
			continue;

		// TODO: if fScale > 0.5f, do the lerp in the other direction; this is
		// because we want fScale to be close to 0, not 1, to retain accuracy.
		fScale = (0 - pv0.data[2]) / (pv1.data[2] - pv0.data[2]);

		x = fScale * pv1.data[0] + (1.0 - fScale) * pv0.data[0];
		y = fScale * pv1.data[1] + (1.0 - fScale) * pv0.data[1];
		w = fScale * pv1.data[3]+ (1.0 - fScale) * pv0.data[3];

		if(x > -w)
			dwClipFlags |= 1 << 0;

		if(x < w)
			dwClipFlags |= 1 << 1;

		if(y > -w)
			dwClipFlags |= 1 << 2;

		if(y < w)
			dwClipFlags |= 1 << 3;
	}

	if(dwClipFlags === 0x0F)
		return true;

	return false;
}

/*!***********************************************************************
@Function		PVRTShadowVolBoundingBoxExtrude
@Modified		pvExtrudedCube	8 Vertices to represent the extruded box
@Input			pBoundingBox	The bounding box to extrude
@Input			pvLightMdl		The light position/direction
@Input			bPointLight		Is the light a point light
@Input			fVolLength		The length the volume has been extruded by
@Description	Extrudes the bounding box of the volume
// *************************************************************************/
// void PVRTShadowVolBoundingBoxExtrude(
// 	PVRTVECTOR3				* const pvExtrudedCube,
// 	const PVRTBOUNDINGBOX	* const pBoundingBox,
// 	const PVRTVECTOR3		* const pvLightMdl,
// 	const bool				bPointLight,
//     const float				fVolLength)
    function PVRTShadowVolBoundingBoxExtrude(
         pvExtrudedCube,
       pBoundingBox,
    pvLightMdl,
      		bPointLight,
       		fVolLength)
{
	let i = 0 // int;

	if(bPointLight) {
		i = 8;
		while(i>0)
		{
			i--;

			pvExtrudedCube[i].data[0] = pBoundingBox.Point[i].data[0] + fVolLength * (pBoundingBox.Point[i].data[0] - pvLightMdl.data[0]);
			pvExtrudedCube[i].data[1] = pBoundingBox.Point[i].data[1] + fVolLength * (pBoundingBox.Point[i].data[1] - pvLightMdl.data[1]);
			pvExtrudedCube[i].data[2] = pBoundingBox.Point[i].data[2] + fVolLength * (pBoundingBox.Point[i].data[2] - pvLightMdl.data[2]);
		}
	} else {
		i = 8;
		while(i>0)
		{
			i--;

			pvExtrudedCube[i].data[0] = pBoundingBox.Point[i].data[0] + fVolLength * pvLightMdl.data[0];
			pvExtrudedCube[i].data[1] = pBoundingBox.Point[i].data[1] + fVolLength * pvLightMdl.data[1];
			pvExtrudedCube[i].data[2] = pBoundingBox.Point[i].data[2] + fVolLength * pvLightMdl.data[2];
		}
	}
}



function PVRTTransformVec3Array(pOut, nOutStride, pV, nInStride, pMatrix, numberOfVertices){
    let pSrc = pV;
    let pDst = pOut;
    for (let i =0 ; i< numberOfVertices; i ++){
    pDst.x = pMatrix.data[0] * pSrc.x + pMatrix.data[4] * pSrc.y + pMatrix.data[8] * pSrc.z + pMatrix.data[12];
    pDst.y = pMatrix.data[1] * pSrc.x + pMatrix.data[5] * pSrc.y + pMatrix.data[9] * pSrc.z + pMatrix.data[13];
    pDst.z = pMatrix.data[2] * pSrc.x + pMatrix.data[6] * pSrc.y + pMatrix.data[10] * pSrc.z + pMatrix.data[14];
    pDst.w = pMatrix.data[3] * pSrc.x + pMatrix.data[7] * pSrc.y + pMatrix.data[11] * pSrc.z + pMatrix.data[15];

    pSrc = (pSrc + nInStride);
    pDst = (pDst + nOutStride);

  } 



}
/*!***********************************************************************
@Function		PVRTShadowVolBoundingBoxIsVisible
@Modified		pdwVisFlags		Visibility flags
@Input			bObVisible		Unused set to true
@Input			bNeedsZClipping	Unused set to true
@Input			pBoundingBox	The volumes bounding box
@Input			pmTrans			The projection matrix
@Input			pvLightMdl		The light position/direction
@Input			bPointLight		Is the light a point light
@Input			fCamZProj		The camera's z projection value
@Input			fVolLength		The length the volume is extruded by
@Description	Determines if the volume is visible and if it needs caps
*************************************************************************/
// void PVRTShadowVolBoundingBoxIsVisible(
// 	unsigned int			* const pdwVisFlags,
// 	const bool				bObVisible,				// Is the object visible?
// 	const bool				bNeedsZClipping,		// Does the object require Z clipping?
// 	const PVRTBOUNDINGBOX	* const pBoundingBox,
// 	const PVRTMATRIX		* const pmTrans,
// 	const PVRTVECTOR3		* const pvLightMdl,
// 	const bool				bPointLight,
// 	const float				fCamZProj,
//     const float				fVolLength)
// function PVRTShadowVolBoundingBoxIsVisible(
//          pdwVisFlags,
//        		bObVisible,				// Is the object visible?
//        		bNeedsZClipping,		// Does the object require Z clipping?
//    pBoundingBox,
//         pmTrans,
//         pvLightMdl,
//       			bPointLight,
//       			fCamZProj,
//      		fVolLength)
// {
//     let		pvExtrudedCube= new Array(8);
//     for (let i = 0; i<8 ; i++) {pvExtrudedCube[i] = new PVRVector3()};

//     let		BoundingHyperCubeT = new Array(16);
//     for (let i = 0; i<16; i++) {BoundingHyperCubeT[i] = new PVRVector4()};
// 	let				i = 0
// 	let dwClipFlagsA, dwClipZCnt = 0;  //	unsigned int
// 	let			fLightProjZ = 0; //float

// 	// PVRT_UNREFERENCED_PARAMETER(bObVisible);
// 	// PVRT_UNREFERENCED_PARAMETER(bNeedsZClipping);

// //	_ASSERT((bObVisible && bNeedsZClipping) || !bNeedsZClipping);

// 	/*
// 		Transform the eight bounding box points into projection space
// 	*/
// 	//PVRTTransformVec3Array(BoundingHyperCubeT[0], sizeof(BoundingHyperCubeT), pBoundingBox.Point,	sizeof(pBoundingBox.Point),	pmTrans, 8);
//     PVRTTransformVec3Array(BoundingHyperCube, pBoundingBox.Point, pmTrans, 8);

// 	/*
// 		Get the light Z coordinate in projection space
// 	*/
// 	fLightProjZ =
// 		pmTrans.f[ 2] * pvLightMdl.data[0] +
// 		pmTrans.f[ 6] * pvLightMdl.data[1] +
// 		pmTrans.f[10] * pvLightMdl.data[2] +
// 		pmTrans.f[14];

// 	/*
// 		Where is the object relative to the near clip plane and light?
// 	*/
// 	dwClipZCnt		= 0;
// 	dwClipFlagsA	= 0;
// 	i = 8;
// 	while(i>0) {
// 		i--;

// 		if(BoundingHyperCubeT[i].data[2] <= 0)
// 			++dwClipZCnt;

// 		if(BoundingHyperCubeT[i].data[2] <= fLightProjZ)
// 			++dwClipFlagsA;
// 	}

// 	if(dwClipZCnt === 8 && dwClipFlagsA === 8) {
// 		// hidden
// 		pdwVisFlags = 0;
// 		return;
// 	}

// 	/*
// 		Shadow the bounding box into pvExtrudedCube.
// 	*/
// 	PVRTShadowVolBoundingBoxExtrude(pvExtrudedCube, pBoundingBox, pvLightMdl, bPointLight, fVolLength);

// 	/*
// 		Transform to projection space
// 	*/
// 	PVRTTransformVec3Array(BoundingHyperCubeT[8], sizeof(BoundingHyperCubeT), pvExtrudedCube, sizeof(pvExtrudedCube), pmTrans, 8);

// 	/*
// 		Check whether any part of the hyper bounding box is even visible
// 	*/
// 	if(!IsHyperBoundingBoxVisibleEx(BoundingHyperCubeT, fCamZProj)) {
// 		pdwVisFlags = 0;
// 		return;
// 	}

// 	/*
// 		It's visible, so choose a render method
// 	*/
// 	if(dwClipZCnt === 8) {
// 		// 1
// 		if(IsFrontClipInVolume(BoundingHyperCubeT)) {
// 			pdwVisFlags = PVRTSHADOWVOLUME_VISIBLE | PVRTSHADOWVOLUME_NEED_ZFAIL;

// 			if(IsBoundingBoxVisibleEx(BoundingHyperCubeT[8], fCamZProj))
// 			{
// 				pdwVisFlags |= PVRTSHADOWVOLUME_NEED_CAP_BACK;
// 			}
// 		} else {
// 			pdwVisFlags = PVRTSHADOWVOLUME_VISIBLE;
// 		}
// 	} else {
// 		if(!(dwClipZCnt | dwClipFlagsA)) {
// 			// 3
// 			pdwVisFlags = PVRTSHADOWVOLUME_VISIBLE;
// 		} else {
// 			// 5
// 			if(IsFrontClipInVolume(BoundingHyperCubeT)) {
// 				pdwVisFlags = PVRTSHADOWVOLUME_VISIBLE | PVRTSHADOWVOLUME_NEED_ZFAIL;

// 				if(IsBoundingBoxVisibleEx(BoundingHyperCubeT, fCamZProj))
// 				{
// 					pdwVisFlags |= PVRTSHADOWVOLUME_NEED_CAP_FRONT;
// 				}

// 				if(IsBoundingBoxVisibleEx(BoundingHyperCubeT[8], fCamZProj))
// 				{
// 					pdwVisFlags |= PVRTSHADOWVOLUME_NEED_CAP_BACK;
// 				}
// 			} else {
// 				pdwVisFlags = PVRTSHADOWVOLUME_VISIBLE;
// 			}
// 		}
// 	}
// }

/*!***********************************************************************
@Function		PVRTShadowVolSilhouetteProjectedRender
@Input			psMesh		Shadow volume mesh
@Input			psVol		Renderable shadow volume information
@Input			pContext	A struct for passing in API specific data
@Description	Draws the shadow volume
*************************************************************************/
// int PVRTShadowVolSilhouetteProjectedRender(
// 	const PVRTShadowVolShadowMesh	* const psMesh,
// 	const PVRTShadowVolShadowVol	* const psVol,
//     const SPVRTContext				* const pContext)

PVRModelShadow.prototype.PVRTShadowVolSilhouetteProjectedRender = function (gl,
        psMesh,
         psVol, renderIDs)
       // pContext)
{




// #if defined(BUILD_OGL) || defined(BUILD_OGLES2) || defined(BUILD_OGLES) || defined(BUILD_OGLES3)
// 	_ASSERT(psMesh.pivb);

// #if defined(_DEBUG) // To fix error in Linux
// 	_ASSERT(psVol.nIdxCnt <= psVol.nIdxCntMax);
// 	_ASSERT(psVol.nIdxCnt % 3 == 0);
// 	_ASSERT(psVol.nIdxCnt / 3 <= 0xFFFF);
// #endif


// #if defined(BUILD_OGLES)
// 	_ASSERT(pContext && pContext.pglesExt);

//	gl.getIntegerv(gl.currentProgram, i32CurrentProgeam);

	//glVertexPointer(3, gl.FLOAT, sizeof(SVertexShVol), &((SVertexShVol*)psMesh.pivb)[0].data[0]);
    gl.bindBuffer(gl.ARRAY_BUFFER, renderIDs[0]);
    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, renderIDs[1]);
gl.vertexAttribPointer(0, 3, gl.FLOAT, gl.FALSE, 4*4, 0);
gl.enableVertexAttribArray(0);
gl.vertexAttribPointer(1, 4, gl.UNSIGNED_BYTE, gl.FALSE, 4*4, 12);
gl.enableVertexAttribArray(1);
    //pContext.pglesExt.glMatrixIndexPointerOES(1, gl.UNSIGNED_BYTE, sizeof(SVertexShVol), &((SVertexShVol*)psMesh.pivb)[0].dwExtrude);
	//pContext.pglesExt.glWeightPointerOES(1, GL_FLOAT, sizeof(SVertexShVol), &((SVertexShVol*)psMesh.pivb)[0].fWeight);

	//gl.drawElements(gl.TRIANGLES, psVol.nIdxCnt, gl.UNSIGNED_SHORT, psVol.piib);
    
    gl.drawElements(gl.TRIANGLES, psVol.nIdxCnt, gl.UNSIGNED_SHORT, 0);

 
	gl.disableVertexAttribArray(0);
    gl.disableVertexAttribArray(1);


	return psVol.nIdxCnt / 3;

}


return (null)

}


export default PVRModelShadow